import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  TextInputField,
  SelectInputField,
} from '../../../components/input';
import SectionTitle from '../../../components/SectionTitle.js';
import Button from '../../../components/Button.js';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const stateOptions = {
  'Australian Capital Territory': 'ACT',
  'New South Wales': 'NSW',
  'Nothern Territory': 'NT',
  'Queensland': 'QLD',
  'South Australia': 'SA',
  'Tasmania': 'TAS',
  'Victoria': 'VIC',
  'Western Australia': 'WA'
};
const activeOptions = ['yes', 'no'];

const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    padding: '0',
  },
  title: {
    marginBottom: '1rem',
  },
  controls: {
    padding: '1rem 0',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: '1rem',
  },
});

const PremisesEditForm = ({premise, handleChange, busy=false, back, save, children}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ExpansionPanel defaultExpanded>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-primary"
          id="panel-primary"
        >
          <SectionTitle title="Primary Details" />
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>

          <TextInputField
            label="Name"
            value={premise.name}
            onChange={(event) => handleChange(event, 'name')}
          />
          <SelectInputField
            label="Active"
            value={premise.active ? 'yes' : 'no'}
            options={activeOptions}
            onChange={(event) => handleChange(event, 'active')}
          />
          <TextInputField
            label="Address Line 1"
            value={premise.address_line_1}
            onChange={(event) => handleChange(event, 'address_line_1')}
          />
          <TextInputField
            label="Address Line 2"
            value={premise.address_line_2}
            onChange={(event) => handleChange(event, 'address_line_2')}
          />
          <TextInputField
            label="Suburb"
            value={premise.suburb}
            onChange={(event) => handleChange(event, 'suburb')}
          />
          <SelectInputField
            label="State"
            value={premise.state}
            options={stateOptions}
            onChange={(event) => handleChange(event, 'state')}
          />
          <TextInputField
            label="Post Code"
            value={premise.post_code}
            onChange={(event) => handleChange(event, 'post_code')}
          />

        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel defaultExpanded>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-contact"
          id="panel-contact"
        >
          <SectionTitle title="Contact Details" />
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <TextInputField
            label="Phone"
            value={premise.phone}
            onChange={(event) => handleChange(event, 'phone')}
          />
          <TextInputField
            label="Email"
            value={premise.email}
            onChange={(event) => handleChange(event, 'email')}
          />
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <div className={classes.controls}>
        {children}
        <Button
          variant="outlined"
          color="primary"
          onClick={back}
          label="Back"
          className={classes.button}
          pointer="left"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={save}
          label="Save"
          busy={busy}
          className={classes.button}
          pointer="none"
        />
      </div>

    </div>
  );
};

PremisesEditForm.propTypes = {
  premise: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  busy: PropTypes.bool,
  back: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
};

export default PremisesEditForm;
